export default __webpack_public_path__ + "static/media/background2.b398a828.jpg";